function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.586 7L7.293 3.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L10.586 9H3a1 1 0 010-2h7.586z"
});

function SvgArrowRight16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjU4NTggN0w3LjI5Mjg5IDMuNzA3MTFDNi45MDIzNyAzLjMxNjU4IDYuOTAyMzcgMi42ODM0MiA3LjI5Mjg5IDIuMjkyODlDNy42ODM0MiAxLjkwMjM3IDguMzE2NTggMS45MDIzNyA4LjcwNzExIDIuMjkyODlMMTMuNzA3MSA3LjI5Mjg5QzE0LjA5NzYgNy42ODM0MiAxNC4wOTc2IDguMzE2NTggMTMuNzA3MSA4LjcwNzExTDguNzA3MTEgMTMuNzA3MUM4LjMxNjU4IDE0LjA5NzYgNy42ODM0MiAxNC4wOTc2IDcuMjkyODkgMTMuNzA3MUM2LjkwMjM3IDEzLjMxNjYgNi45MDIzNyAxMi42ODM0IDcuMjkyODkgMTIuMjkyOUwxMC41ODU4IDlIM0MyLjQ0NzcyIDkgMiA4LjU1MjI4IDIgOEMyIDcuNDQ3NzIgMi40NDc3MiA3IDMgN0gxMC41ODU4WiIvPgo8L3N2Zz4K";
export { SvgArrowRight16 as ReactComponent };